import { CSSProperties, useContext, useMemo, useState } from 'react';

import { Editor, IAllProps as EditorProps } from '@tinymce/tinymce-react';

import { AppContext } from 'contexts/AppContext';

import LayoutWithMenu from '../Layout/LayoutWithMenu';

const isHiddenStyles: CSSProperties = {
  position: 'absolute',
  left: '-9999px',
  top: '-9999px',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  visibility: 'hidden',
  zIndex: -999,
};

const HtmlEditor = () => {
  const {
    state: { creds },
  } = useContext(AppContext);
  const [isEditorReady, setIsEditorReady] = useState(false);

  const fields = [
    { key: 'firstName', label: 'First Name', value: 'Luiz' },
    { key: 'lastName', label: 'Last Name', value: 'Oliveira' },
    { key: 'abn', label: 'ABN', value: '123456789' },
    { key: 'companyName', label: 'Company Name', value: 'April9' },
  ];

  const dragCallback = (e: any) => {
    e.dataTransfer.setData(
      'text/html',
      `<span class="dynamic-variable" contentEditable=false>@${e.target.textContent}</span>`,
    );
  };

  const handleEditorChange = (content: string, _editor: any) => {
    let html = content;

    fields?.forEach(field => {
      html = html.split(`@${field.label}`).join(field.value);
    });

    const previewHtml = document.getElementById('previewHtml');
    if (previewHtml) {
      previewHtml.innerHTML = html;
    }
  };

  const initProps: EditorProps['init'] = useMemo(() => {
    const images_upload_handler: NonNullable<
      EditorProps['init']
    >['images_upload_handler'] = async (blobInfo, _progress) => {
      const file = blobInfo.blob();
      const base64 = blobInfo.base64();

      return Promise.resolve(`data:${file.type};base64,${base64}`);
    };

    return {
      body_class: 'Editor',
      height: 500,
      images_upload_handler: images_upload_handler,
      content_css: '/htmlEditor.css',
      plugins: [
        'advlist',
        'autolink',
        'lists',
        'link',
        'image',
        'charmap',
        'preview',
        'anchor',
        'searchreplace',
        'visualblocks',
        'code',
        'fullscreen',
        'insertdatetime',
        'media',
        'table',
        'help',
        'wordcount',
      ],
      toolbar:
        'undo redo | blocks | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help | image | code',
      paste_as_text: false,
      automatic_uploads: false,
      convert_urls: true,
      relative_urls: false,
    };
  }, []);

  return (
    <LayoutWithMenu>
      <br />
      {/* ========= Fields ========= */}
      {fields?.map(field => (
        <div
          key={field.key}
          id={field.key}
          draggable="true"
          onDragStart={dragCallback}
          style={{ border: 'solid 1px #CCC', padding: '5px', width: '300px' }}
        >
          {field.label}
        </div>
      ))}
      <br />
      {!isEditorReady && (
        <div style={{ height: 500, background: '#f5f5f5', borderRadius: 4 }} />
      )}
      <div style={isEditorReady ? {} : isHiddenStyles}>
        <Editor
          apiKey={creds?.tinymce?.apiKey || ''}
          init={initProps}
          onEditorChange={handleEditorChange}
          onInit={() => setIsEditorReady(true)}
        />
      </div>
      <br />
      {/* ========= Preview ========= */}
      <div id="previewHtml" />
    </LayoutWithMenu>
  );
};

export default HtmlEditor;
